import { render, staticRenderFns } from "./seguimiento.vue?vue&type=template&id=47175cca&scoped=true&"
import script from "./seguimiento.vue?vue&type=script&lang=js&"
export * from "./seguimiento.vue?vue&type=script&lang=js&"
import style0 from "./seguimiento.vue?vue&type=style&index=0&id=47175cca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47175cca",
  null
  
)

export default component.exports